"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialPageClasses = void 0;
var _mui = require("@ori-ui/mui");
const editorialPageClasses = exports.editorialPageClasses = (0, _mui.generateUtilityClasses)('EditorialPage', ['categoriesSection', 'editorialCarouselRoot', 'inner', 'root']);
